const styles = {
  // Layout
  root: {
    backgroundColor: '#F3F4F6',
    color: '#1B2B3E',
    fontFamily: "'Inter', sans-serif",
    lineHeight: '1.5',
    overflowX: 'hidden',
    minHeight: '100vh',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 32px',
    position: 'relative',
  },

  // Nav
  nav: {
    padding: '32px 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'sticky',
    top: 0,
    backgroundColor: '#F3F4F6',
    zIndex: 100,
  },
  logo: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '24px',
    letterSpacing: '-0.5px',
    color: '#1B2B3E',
    textTransform: 'uppercase',
    fontWeight: 700,
    cursor: 'pointer',
    textDecoration: 'none',
  },
  navLinks: {
    display: 'flex',
    gap: '32px',
  },
  navItem: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#1B2B3E',
    textDecoration: 'none',
    position: 'relative',
    cursor: 'pointer',
  },

  // Hero
  hero: {
    paddingTop: '120px',
    paddingBottom: '120px',
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  heroTitle: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: 'clamp(60px, 12vw, 160px)',
    lineHeight: '0.9',
    color: '#1B2B3E',
    marginBottom: '32px',
    letterSpacing: '-2px',
  },
  heroTitleUpper: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: 'clamp(60px, 8vw, 120px)',
    lineHeight: '0.9',
    color: '#1B2B3E',
    marginBottom: '32px',
    letterSpacing: '-2px',
    textTransform: 'uppercase',
  },
  heroSub: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '20px',
    fontWeight: 500,
    color: '#475569',
    maxWidth: '600px',
    letterSpacing: '-0.01em',
  },

  // CTA
  ctaGroup: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  ctaText: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '18px',
    fontWeight: 600,
    color: '#1B2B3E',
    marginRight: '16px',
  },
  ctaTextLight: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '18px',
    fontWeight: 600,
    color: '#fff',
    marginRight: '16px',
  },
  ctaIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
  },
  ctaIconHover: {
    transform: 'translateX(10px)',
  },

  // Section Headers
  sectionHeader: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '48px',
    marginBottom: '64px',
    letterSpacing: '-1px',
    color: '#1B2B3E',
  },

  // Services
  servicesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '64px',
    marginBottom: '180px',
  },
  serviceCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: '32px',
    borderTop: '2px solid rgba(27, 43, 62, 0.1)',
    transition: 'border-color 0.3s ease',
  },
  serviceCardHover: {
    borderTop: '2px solid #1B2B3E',
  },
  serviceTitle: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '32px',
    marginBottom: '16px',
    color: '#1B2B3E',
  },
  serviceDesc: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '16px',
    color: '#475569',
    maxWidth: '300px',
  },

  // Stats
  statsSection: {
    padding: '120px 0',
    borderTop: '1px solid rgba(27, 43, 62, 0.05)',
    borderBottom: '1px solid rgba(27, 43, 62, 0.05)',
    marginBottom: '180px',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '48px 32px',
  },
  statNumber: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: 'clamp(64px, 10vw, 96px)',
    lineHeight: '1',
    color: '#1B2B3E',
    display: 'block',
    marginBottom: '8px',
  },
  statLabel: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    color: '#475569',
  },

  // Blog
  blogSection: {
    paddingBottom: '180px',
  },
  blogGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '32px',
  },
  blogCard: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  blogImg: {
    width: '100%',
    aspectRatio: '4/3',
    objectFit: 'cover',
    display: 'block',
    marginBottom: '16px',
    filter: 'grayscale(20%)',
    transition: 'filter 0.3s ease',
  },
  blogImgHover: {
    filter: 'grayscale(0%)',
  },
  blogTag: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '11px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    color: '#475569',
    marginBottom: '8px',
  },
  blogTitle: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '22px',
    color: '#1B2B3E',
    lineHeight: '1.1',
    marginBottom: '8px',
    letterSpacing: '-0.5px',
  },
  blogExcerpt: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '14px',
    color: '#475569',
    lineHeight: '1.6',
  },

  // Contact / Form
  contactSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '64px',
    paddingBottom: '180px',
  },
  formGroup: {
    marginBottom: '32px',
  },
  minimalInput: {
    width: '100%',
    background: 'transparent',
    border: 'none',
    borderBottom: '2px solid rgba(27, 43, 62, 0.2)',
    fontFamily: "'Antonio', sans-serif",
    fontSize: '32px',
    color: '#1B2B3E',
    padding: '16px 0',
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },

  // Detail labels (process steps, contact info)
  detailLabel: {
    fontSize: '12px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    color: '#475569',
    marginBottom: '4px',
    display: 'block',
  },
  detailValue: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#1B2B3E',
  },

  // Info blocks (from react-app-4)
  infoLabel: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '1.5px',
    color: '#475569',
    marginBottom: '16px',
    display: 'block',
  },
  infoDetail: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '28px',
    color: '#1B2B3E',
    lineHeight: '1.2',
    textDecoration: 'none',
    display: 'block',
  },

  // Process timeline
  stepNumber: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '48px',
    color: 'rgba(27, 43, 62, 0.2)',
    lineHeight: '1',
  },
  stepTitle: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '42px',
    marginBottom: '16px',
    textTransform: 'uppercase',
    letterSpacing: '-1px',
    color: '#1B2B3E',
  },
  stepDesc: {
    fontSize: '18px',
    color: '#475569',
    lineHeight: '1.6',
  },

  // Expectations / dark sections
  expectionsSection: {
    backgroundColor: '#1B2B3E',
    color: '#F3F4F6',
    padding: '120px 0',
    marginBottom: '180px',
  },
  expectionsTitle: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '64px',
    marginBottom: '64px',
    letterSpacing: '-1px',
    textTransform: 'uppercase',
    color: '#fff',
  },
  expectCardTitle: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '24px',
    marginBottom: '16px',
    color: '#fff',
  },
  expectCardDesc: {
    fontSize: '15px',
    color: 'rgba(243, 244, 246, 0.7)',
    lineHeight: '1.6',
  },

  // Booking CTA (from react-app-4)
  bookingTitle: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '64px',
    lineHeight: '0.9',
    marginBottom: '16px',
  },
  bookingSub: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '18px',
    opacity: 0.8,
    maxWidth: '400px',
  },

  // Map placeholder
  mapLabel: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '24px',
    color: 'rgba(27, 43, 62, 0.2)',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    zIndex: 1,
  },

  // Footer
  footer: {
    padding: '64px 0',
    borderTop: '1px solid rgba(27, 43, 62, 0.1)',
  },
  footerGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  footerBrand: {
    fontFamily: "'Antonio', sans-serif",
    fontSize: '24px',
    marginBottom: '8px',
    color: '#1B2B3E',
  },
  copyright: {
    fontFamily: "'Inter', sans-serif",
    fontSize: '14px',
    color: '#475569',
  },
};

export default styles;
